import { render, staticRenderFns } from "./ExpensesBudgetInput.vue?vue&type=template&id=5777a5ec&"
import script from "./ExpensesBudgetInput.vue?vue&type=script&lang=js&"
export * from "./ExpensesBudgetInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports